import { useState, useEffect, useRef, useCallback } from "react";
import Consultation from "../pages/Consultation"; // ← adjust path to match your project
import operationtheator from "../assets/images/operation-theator.png";
import Patientward from "../assets/images/Patientward.jpg";
import Pharmacy from "../assets/images/Pharmacy.jpg";
import Oncologyglimpse from "../assets/images/Glimpse/Oncology.jpeg";
import Nursestationglimpse from "../assets/images/Glimpse/Nursingstation.webp";
import Otsuitglimpse from "../assets/images/Glimpse/Otsuit.png";
import Icusuitglimpse from "../assets/images/Glimpse/Icusuit.jpg";
import Diagnosticglimpse from "../assets/images/Glimpse/Diagnosics.webp";
import Receptionglimpse from "../assets/images/Glimpse/ReceptionLobby.png";
import SEO from "../components/SEO";

const STORES = [
  {
    id: 1,
    name: "PR Hospital Designers",
    city: "Vijayawada",
    state: "Andhra Pradesh",
    tag: "Hospital Infrastructure",
    address: "54-15-1B, beside Yalamanchili Nageswara Rao Mansion, Veterinary Colony, Vijayawada, Andhra Pradesh 520008",
    phone: "+91 9993999840",
    email: "vijayawada@tevah.in",
    hours: "Mon – Sat | 10:00 AM – 7:00 PM",
    tourDuration: "Site Consultation — 60 minutes",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.3766877453427!2d80.662521!3d16.50707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb000d1b7e69%3A0x319bddf104038f0b!2sPR%20HOSPITAL%20DESIGNERS!5e0!3m2!1sen!2sin!4v1779700631945!5m2!1sen!2sin",
    directionsLink: "https://www.google.com/maps/dir/?api=1&destination=54-15-1B+Veterinary+Colony+Vijayawada+Andhra+Pradesh+520008",
    mapLink: "https://maps.google.com/?q=PR+HOSPITAL+DESIGNERS+Vijayawada",
  },
  {
    id: 2,
    name: "PR Infra & Hospitals Designers",
    city: "Hyderabad",
    state: "Telangana",
    tag: "Hospital Infrastructure",
    address: "8-1/7/7, beside GVR Villa's, Sundar Rao Nagar, Bahadurpally, Hyderabad, Telangana 500043",
    phone: "+91 9993999840",
    email: "hyderabad@tevah.in",
    hours: "Mon – Sat | 10:00 AM – 7:00 PM",
    tourDuration: "Site Consultation — 60 minutes",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.028200465789!2d78.4374018!3d17.553843999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb8fa47427171d%3A0x9cf88d03a573c90d!2sPR%20Infra%20%26%20Hospitals%20designers!5e0!3m2!1sen!2sin!4v1779701600705!5m2!1sen!2sin",
    directionsLink: "https://www.google.com/maps/dir/?api=1&destination=8-1/7/7+Sundar+Rao+Nagar+Bahadurpally+Hyderabad+Telangana+500043",
    mapLink: "https://maps.google.com/?q=PR+Infra+Hospitals+designers+Hyderabad",
  },
];

const EXPECT_ITEMS = [
  {
    img: operationtheator,
    title: "Get a feel of our expertise",
    desc: "At PR Hospital Designers, seeing is believing. Explore real hospital infrastructure projects, ICU models and OT layouts that will inspire your vision.",
  },
  {
    img: Patientward,
    title: "Stunning layouts for every space",
    desc: "Take a walkthrough of beautifully designed OTs, patient wards, diagnostic centres and everything in between.",
  },
  {
    img: Pharmacy,
    title: "Material and finish options",
    desc: "Be spoilt for choice! Pick from a wide range of clinical finishes, anti-microbial surfaces, flooring and more.",
  },
  {
    img: Oncologyglimpse,
    title: "Expert clinical consultation",
    desc: "There's always a hospital infrastructure specialist ready to listen, plan and design your facility within budget.",
  },
];

const FAQS = [
  { q: "I am looking for a hospital infrastructure designer near me, help!", a: "PR Hospital Designers has experience centres in Vijayawada and Hyderabad. Walk in to consult our clinical specialists who can help plan ICUs, OTs, diagnostic centres and more — fully NABH-compliant." },
  { q: "How long does a consultation at the Experience Centre take?", a: "A typical hospital infrastructure consultation lasts 60–90 minutes. For complex projects like full hospital builds, we recommend booking a dedicated 2-hour session." },
  { q: "What is the cost of hospital infrastructure design?", a: "Costs vary by project scope — ICU fit-outs start from ₹80L, diagnostic centres from ₹1.2Cr, and full ward blocks from ₹2Cr. We provide detailed estimates after a free site consultation." },
  { q: "What is the starting price for hospital infrastructure near me?", a: "Our hospital infrastructure services start from ₹80 lakhs for ICU fit-outs, with full greenfield hospital projects starting from ₹5Cr depending on size and specifications." },
  { q: "What will be the timelines for my hospital project?", a: "OT fit-outs typically take 60–90 days. Full ward blocks or diagnostic centres take 120–180 days. We provide 24/7 project support and dedicated managers throughout." },
];

const PEEK_SLIDES = [
  {
    img: Nursestationglimpse,
    title: "World-class hospital design, up close",
    desc: "Explore real-scale hospital corridor layouts and clinical space mockups designed to NABH standards.",
  },
  {
    img: Otsuitglimpse,
    title: "Operation Theatre fit-outs",
    desc: "Step inside our OT model — laminar flow systems, sterile zones, and surgical lighting, all compliant.",
  },
  {
    img: Icusuitglimpse,
    title: "ICU suites built for healing",
    desc: "We design intensive care units that balance clinical precision with patient comfort and infection control.",
  },
  {
    img: Diagnosticglimpse,
    title: "Diagnostic & lab environments",
    desc: "From radiology suites to pathology labs — efficient, regulation-ready spaces that keep workflow seamless.",
  },
  {
    img: Receptionglimpse,
    title: "Patient-first reception & waiting",
    desc: "Calming, welcoming lobbies and waiting areas that set the right tone the moment patients walk through the door.",
  },
];

/* ══════════════════════════════════════════════════════
   GLOBE CAROUSEL  — 3D circular ring rotation
   Cards are positioned on a 3D ring using perspective.
   Each card's X and Z position is computed from its
   angular distance from the active (front) card.
══════════════════════════════════════════════════════ */
function GlobeCarousel() {
  const N = PEEK_SLIDES.length;
  const RADIUS = 520; // ring depth radius in px — tune for spread

  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);
  const dragStartX = useRef(null);

  const goTo = useCallback((idx) => {
    setCurrent(((idx % N) + N) % N);
  }, [N]);

  const restartTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % N);
    }, 3200);
  }, [N]);

  useEffect(() => {
    restartTimer();
    return () => clearInterval(timerRef.current);
  }, [restartTimer]);

  const handleStep = (dir) => {
    goTo(current + dir);
    restartTimer();
  };

  const handleDotClick = (i) => {
    goTo(i);
    restartTimer();
  };

  /* drag / swipe */
  const onDragStart = (clientX) => { dragStartX.current = clientX; };
  const onDragEnd = (clientX) => {
    if (dragStartX.current === null) return;
    const dx = clientX - dragStartX.current;
    if (Math.abs(dx) > 50) handleStep(dx < 0 ? 1 : -1);
    dragStartX.current = null;
  };

  return (
    <div className="gc-root">
      {/* 3D scene */}
      <div
        className="gc-scene"
        onMouseDown={(e) => onDragStart(e.clientX)}
        onMouseUp={(e) => onDragEnd(e.clientX)}
        onTouchStart={(e) => onDragStart(e.touches[0].clientX)}
        onTouchEnd={(e) => onDragEnd(e.changedTouches[0].clientX)}
      >
        <div className="gc-ring">
          {PEEK_SLIDES.map((slide, i) => {
            /* angular difference from current, mapped 0→360 */
            const diff = ((i - current) % N + N) % N;
            const deg = (360 / N) * diff;
            const rad = (deg * Math.PI) / 180;

            const x = Math.sin(rad) * RADIUS;
            const z = Math.cos(rad) * RADIUS - RADIUS;
            const cosVal = Math.cos(rad);
            const scale = 0.52 + 0.48 * ((cosVal + 1) / 2);
            const opacity = 0.25 + 0.75 * ((cosVal + 1) / 2);
            const zIndex = Math.round(scale * 100);
            const isCenter = i === current;

            return (
              <div
                key={i}
                className={`gc-card${isCenter ? " gc-center" : ""}`}
                style={{
                  transform: `translateX(${x}px) translateZ(${z}px) scale(${scale})`,
                  opacity,
                  zIndex,
                }}
                onClick={() => {
                  if (!isCenter) {
                    goTo(i);
                    restartTimer();
                  }
                }}
              >
                <img src={slide.img} alt={slide.title} />
                {isCenter && (
                  <div className="gc-caption">
                    <div className="gc-caption-title">{slide.title}</div>
                    <div className="gc-caption-desc">{slide.desc}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Controls */}
      <div className="gc-controls">
        <button className="gc-arr" onClick={() => handleStep(-1)}>‹</button>
        <div className="gc-dots">
          {PEEK_SLIDES.map((_, i) => (
            <button
              key={i}
              className={`gc-dot${i === current ? " gc-dot-on" : ""}`}
              onClick={() => handleDotClick(i)}
            />
          ))}
        </div>
        <button className="gc-arr" onClick={() => handleStep(1)}>›</button>
      </div>

      <div className="gc-counter">
        {String(current + 1).padStart(2, "0")} / {String(N).padStart(2, "0")}
      </div>
    </div>
  );
}

export default function StoreLocator() {
  const [activeStore, setActiveStore] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [showConsultation, setShowConsultation] = useState(false);

  const openConsultation = () => setShowConsultation(true);
  const closeConsultation = () => setShowConsultation(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showConsultation ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showConsultation]);

  return (
     <>
    <SEO/>
    <div className="sl-page" style={{ background: "#fff", color: "#343F86", overflowX: "hidden" }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        img { display: block; }
        html { scroll-behavior: smooth; }

        .sl-page {
          font-family: 'Inter', 'Montserrat', sans-serif;
          padding-top: 68px;
        }
        @media (max-width: 900px) { .sl-page { padding-top: 60px; } }
        @media (max-width: 480px) { .sl-page { padding-top: 56px; } }

        /* ── Hero (dark, matches site-wide hero style — no image) ── */
        .sl-hero {
          background: #343F86;
          padding: 96px 48px 56px;
          position: relative;
          overflow: hidden;
        }
        .sl-hero-grid {
          position: absolute; inset: 0;
          background-image: linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
          background-size: 48px 48px;
        }
        .sl-hero-inner { position: relative; z-index: 2; max-width: 1200px; margin: 0 auto; }
        .sl-hero-eyebrow {
          display: inline-block;
          font-size: 11px; font-weight: 600; letter-spacing: 3px;
          text-transform: uppercase; color: #7FD0DA;
          background: rgba(255,255,255,0.08); padding: 6px 14px;
          border-radius: 4px; margin-bottom: 24px;
        }
        .sl-hero h1 {
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: clamp(32px, 5vw, 30px);
          font-weight: 700; color: #fff; line-height: 1.15; margin-bottom: 12px;
         
        }
        .sl-hero p { font-size: 16px; color: #A7ACBD; margin-bottom: 28px;line-height: 1.7; }
        .sl-hero-cta {
          display: inline-block; background: #fff; color: #2F8A98;
          border: none; border-radius: 10px; padding: 13px 32px;
          font-family: 'Inter', 'Montserrat', sans-serif; font-size: 13px;
          font-weight: 700; cursor: pointer; letter-spacing: 0.5px;
          text-transform: uppercase; transition: all 0.2s;
        }
        .sl-hero-cta:hover { background: #CDD1E0; transform: translateY(-2px); }
        @media (max-width: 768px) {
          .sl-hero { padding: 56px 20px; }
          .sl-hero-eyebrow { margin-bottom: 16px; }
          .sl-hero h1 { font-size: 30px; margin-bottom: 10px; }
          .sl-hero p { font-size: 14.5px; margin-bottom: 22px; }
        }

        /* ── Breadcrumb ── */
        .sl-breadcrumb { font-size: 12px; color: #8A8F9C; padding: 12px 24px; max-width: 1200px; margin: 0 auto; }
        .sl-breadcrumb span { color: #343F86; font-weight: 600; }

        /* ── Find section ── */
        .sl-find-section { max-width: 1200px; margin: 0 auto; padding: 0 24px 60px; }
        @media (max-width: 768px) { .sl-find-section { padding: 0 16px 40px; } }
        .sl-find-header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 24px; flex-wrap: wrap; gap: 12px; }
        .sl-find-header h2 { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 26px; font-weight: 700; color: #343F86; }
        .sl-find-header p { font-size: 14px; color: #5B6072; margin-top: 4px; }
        @media (max-width: 768px) { .sl-find-header h2 { font-size: 22px; } }
        .sl-connect-btn {
          background: #343F86; color: #7FD0DA; border: none; border-radius: 8px;
          padding: 11px 24px; font-family: 'Inter', 'Montserrat', sans-serif; font-size: 12px;
          font-weight: 700; cursor: pointer; letter-spacing: 0.5px; text-transform: uppercase;
          white-space: nowrap; align-self: flex-start; transition: all 0.2s;
        }
        .sl-connect-btn:hover { background: #262E63; }

        /* ── Map + List ── */
        .sl-map-list { display: grid; grid-template-columns: 1fr 420px; gap: 0; border: 1px solid #E1E3EE; border-radius: 16px; overflow: hidden; }
        .sl-map-area { position: relative; height: 500px; }
        .sl-map-area iframe { width: 100%; height: 100%; border: none; display: block; }
        .sl-store-panel { background: #fff; border-left: 1px solid #E1E3EE; overflow-y: auto; }
        .sl-panel-count { padding: 16px 20px; border-bottom: 1px solid #ECEEF6; font-size: 12px; font-weight: 700; color: #2F8A98; letter-spacing: 1px; text-transform: uppercase; }
        .sl-store-item { padding: 20px; border-bottom: 1px solid #ECEEF6; cursor: pointer; transition: background 0.15s; }
        .sl-store-item:hover { background: #F6F7FC; }
        .sl-store-item.active { background: #ECEEF6; border-left: 3px solid #343F86; }
        .sl-store-item-name { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 16px; font-weight: 700; color: #343F86; margin-bottom: 4px; }
        .sl-store-item-tag { display: inline-block; font-size: 11px; font-weight: 700; background: #343F86; color: #fff; padding: 2px 8px; border-radius: 4px; margin-bottom: 8px; letter-spacing: 0.5px; }
        .sl-store-item-addr { font-size: 13px; color: #5B6072; line-height: 1.6; margin-bottom: 8px; }
        .sl-store-item-meta { font-size: 12px; color: #8A8F9C; margin-bottom: 2px; }
        .sl-store-item-meta span { font-weight: 600; color: #5B6072; }
        .sl-store-item-actions { display: flex; gap: 8px; margin-top: 12px; align-items: center; flex-wrap: wrap; }
        .sl-book-btn {
          background: #343F86; color: #fff; border: none; border-radius: 7px;
          padding: 8px 16px; font-family: 'Inter', 'Montserrat', sans-serif; font-size: 12px;
          font-weight: 700; cursor: pointer; transition: all 0.2s;
        }
        .sl-book-btn:hover { background: #262E63; }
        .sl-icon-btn {
          width: 32px; height: 32px; border: 1px solid #E1E3EE; border-radius: 7px;
          background: #fff; display: flex; align-items: center; justify-content: center;
          font-size: 15px; cursor: pointer; transition: all 0.2s; flex-shrink: 0; text-decoration: none;
        }
        .sl-icon-btn:hover { background: #ECEEF6; border-color: #A7ACBD; }
        .sl-explore-btn {
          margin-left: auto; font-size: 11px; font-weight: 700; color: #2F8A98;
          background: none; border: none; cursor: pointer;
          letter-spacing: 0.5px; text-transform: uppercase;
          display: flex; align-items: center; gap: 4px;
        }
        .sl-explore-btn:hover { text-decoration: underline; }

        /* ── What to expect ── */
        .sl-expect { background: #F6F7FC; padding: 64px 24px; }
        @media (max-width: 768px) { .sl-expect { padding: 40px 20px; } }
        .sl-expect-inner { max-width: 1200px; margin: 0 auto; }
        .sl-expect h2 { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 26px; font-weight: 700; color: #343F86; margin-bottom: 6px; }
        .sl-expect-sub { font-size: 14px; color: #5B6072; margin-bottom: 36px; }
        @media (max-width: 768px) { .sl-expect h2 { font-size: 22px; } }
        .sl-expect-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
        .sl-expect-card { background: #fff; border-radius: 14px; overflow: hidden; border: 1px solid #E1E3EE; }
        .sl-expect-card img { width: 100%; height: 160px; object-fit: cover; display: block; }
        .sl-expect-card-body { padding: 16px; }
        .sl-expect-card-title { font-size: 14px; font-weight: 700; color: #343F86; margin-bottom: 6px; }
        .sl-expect-card-desc { font-size: 13px; color: #5B6072; line-height: 1.6; }

        /* ══════════════════════════════════════════
           GLOBE CAROUSEL
        ══════════════════════════════════════════ */
        .sl-peek {
          padding: 64px 0 52px;
          text-align: center;
          background: #fff;
        }
        @media (max-width: 768px) { .sl-peek { padding: 40px 0 36px; } }
        .sl-peek-title {
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 26px; font-weight: 700; color: #343F86;
          margin-bottom: 8px; padding: 0 24px;
        }
        @media (max-width: 768px) { .sl-peek-title { font-size: 22px; } }
        .sl-peek-sub {
          font-size: 13px; color: #8A8F9C; margin-bottom: 36px;
        }

        /* 3D scene container */
        .gc-root { width: 100%; }
        .gc-scene {
          width: 100%;
          height: 440px;
          display: flex;
          align-items: center;
          justify-content: center;
          perspective: 1200px;
          cursor: grab;
          overflow: hidden;
        }
        .gc-scene:active { cursor: grabbing; }

        /* The invisible ring — cards absolutely positioned relative to scene center */
        .gc-ring {
          position: relative;
          width: 450px;
          height: 360px;
          transform-style: preserve-3d;
        }

        /* Each card */
        .gc-card {
          position: absolute;
          inset: 0;
          border-radius: 20px;
          overflow: hidden;
          transition: transform 0.85s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                      opacity 0.85s ease,
                      box-shadow 0.85s ease;
          cursor: pointer;
          backface-visibility: hidden;
        }
        .gc-card img {
          width: 100%; height: 100%;
          object-fit: cover; display: block;
          pointer-events: none;
          user-select: none;
        }
        .gc-card.gc-center {
          box-shadow: 0 24px 64px rgba(0,0,0,0.28);
          cursor: default;
        }

        /* Caption overlay — only on front card */
        .gc-caption {
          position: absolute; bottom: 0; left: 0; right: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.78) 0%, transparent 100%);
          padding: 52px 22px 22px;
          text-align: left;
        }
        .gc-caption-title {
          font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 17px; font-weight: 700; color: #fff;
          line-height: 1.3; margin-bottom: 6px;
        }
        .gc-caption-desc {
          font-size: 13px; color: rgba(255,255,255,0.75); line-height: 1.55;
        }

        /* Arrow + dots row */
        .gc-controls {
          display: flex; align-items: center; justify-content: center;
          gap: 16px; margin-top: 28px;
        }
        .gc-arr {
          width: 42px; height: 42px; border-radius: 50%;
          background: #343F86; color: #fff; border: none;
          font-size: 20px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: background 0.2s; flex-shrink: 0;
        }
        .gc-arr:hover { background: #262E63; }
        .gc-dots { display: flex; gap: 8px; align-items: center; }
        .gc-dot {
          height: 3px; border-radius: 2px; border: none; padding: 0;
          cursor: pointer; transition: all 0.35s; background: #CDD1E0; width: 18px;
        }
        .gc-dot.gc-dot-on { width: 36px; background: #343F86; }
        .gc-counter {
          font-size: 12px; font-weight: 700; color: #8A8F9C;
          letter-spacing: 1.5px; text-align: center; margin-top: 12px;
        }

        /* ── Virtual tour ── */
        .sl-vtour { background: #F6F7FC; padding: 64px 24px; }
        @media (max-width: 768px) { .sl-vtour { padding: 40px 20px; } }
        .sl-vtour-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; }
        .sl-vtour h2 { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 26px; font-weight: 700; color: #343F86; margin-bottom: 16px; line-height: 1.25; }
        @media (max-width: 768px) { .sl-vtour h2 { font-size: 22px; margin-bottom: 12px; } }
        .sl-vtour p { font-size: 15px; color: #5B6072; line-height: 1.75; margin-bottom: 28px; }
        .sl-vtour-btn {
          display: inline-flex; align-items: center; gap: 8px;
          background: none; border: 2px solid #343F86; border-radius: 8px;
          padding: 11px 24px; font-family: 'Inter', 'Montserrat', sans-serif;
          font-size: 12px; font-weight: 700; color: #2F8A98; cursor: pointer;
          letter-spacing: 0.5px; text-transform: uppercase; transition: all 0.2s;
        }
        .sl-vtour-btn:hover { background: #343F86; color: #fff; }
        .sl-vtour-img { border-radius: 18px; overflow: hidden; position: relative; }
        .sl-vtour-img img { width: 100%; height: 320px; object-fit: cover; display: block; }
        .sl-vtour-img-badge {
          position: absolute; bottom: 16px; right: 16px;
          background: rgba(0,0,0,0.72); backdrop-filter: blur(8px);
          border-radius: 10px; padding: 8px 14px;
          font-size: 12px; font-weight: 700; color: #fff;
          display: flex; align-items: center; gap: 6px;
        }

        /* ── Reviews ── */
        .sl-reviews { padding: 56px 24px; border-top: 1px solid #ECEEF6; }
        @media (max-width: 768px) { .sl-reviews { padding: 36px 20px; } }
        .sl-reviews-inner { max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 24px; }
        .sl-reviews h2 { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 22px; font-weight: 700; color: #343F86; margin-bottom: 6px; }
        .sl-reviews p { font-size: 13px; color: #5B6072; max-width: 380px; }
        .sl-reviews-badge { display: flex; align-items: center; gap: 14px; background: #fff; border: 1px solid #E1E3EE; border-radius: 16px; padding: 16px 24px; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
        .sl-google-icon { font-size: 28px; }
        .sl-rating-num { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 28px; font-weight: 700; color: #343F86; line-height: 1; }
        .sl-stars { color: #f4b400; font-size: 18px; letter-spacing: 1px; margin-top: 2px; }
        .sl-review-count { font-size: 11px; color: #8A8F9C; margin-top: 3px; }

        /* ── FAQ ── */
        .sl-faq { background: #F6F7FC; padding: 64px 24px; }
        @media (max-width: 768px) { .sl-faq { padding: 40px 20px; } }
        .sl-faq-inner { max-width: 900px; margin: 0 auto; }
        .sl-faq h2 { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 22px; font-weight: 700; color: #343F86; margin-bottom: 28px; }
        @media (max-width: 768px) { .sl-faq h2 { font-size: 20px; margin-bottom: 20px; } }
        .sl-faq-item { border: 1px solid #E1E3EE; border-radius: 12px; margin-bottom: 10px; background: #fff; overflow: hidden; transition: box-shadow 0.2s; }
        .sl-faq-item.open { box-shadow: 0 6px 24px rgba(0,0,0,0.07); }
        .sl-faq-btn { width: 100%; background: none; border: none; padding: 18px 22px; display: flex; justify-content: space-between; align-items: center; gap: 16px; text-align: left; cursor: pointer; font-family: 'Inter', 'Montserrat', sans-serif; font-size: 14px; font-weight: 600; color: #343F86; }
        .sl-faq-icon { font-size: 20px; flex-shrink: 0; transition: transform 0.3s; color: #5B6072; }
        .sl-faq-icon.open { transform: rotate(45deg); }
        .sl-faq-ans { padding: 0 22px 18px; font-size: 13px; color: #5B6072; line-height: 1.8; }

        /* ── Dream banner ── */
        .sl-dream { background: linear-gradient(135deg, #343F86 0%, #262E63 50%, #343F86 100%); padding: 72px 24px; text-align: center; position: relative; overflow: hidden; }
        @media (max-width: 768px) { .sl-dream { padding: 48px 20px; } }
        .sl-dream-dots { position: absolute; inset: 0; opacity: 0.04; background-image: radial-gradient(circle at 50% 50%, #fff 1px, transparent 1px); background-size: 36px 36px; }
        .sl-dream-inner { position: relative; z-index: 1; }
        .sl-dream h2 { font-family: 'Inter', 'Montserrat', sans-serif; font-size: clamp(26px,4vw,40px); font-weight: 700; color: #fff; margin-bottom: 14px; }
        .sl-dream-btn { background: #fff; color: #2F8A98; border: none; border-radius: 10px; padding: 16px 48px; font-family: 'Inter', 'Montserrat', sans-serif; font-size: 13px; font-weight: 700; cursor: pointer; letter-spacing: 0.5px; text-transform: uppercase; transition: all 0.25s; }
        .sl-dream-btn:hover { transform: translateY(-3px); box-shadow: 0 16px 44px rgba(255,255,255,0.18); }
        @media (max-width: 480px) { .sl-dream-btn { width: 100%; padding: 15px 32px; } }

        /* ── Consultation modal ── */
        .sl-modal-overlay {
          position: fixed; inset: 0; z-index: 2000;
          background: rgba(0,0,0,0.65);
          backdrop-filter: blur(5px);
          display: flex; align-items: center; justify-content: center;
          padding: 1rem;
        }
        .sl-modal-inner {
          position: relative; width: 100%; max-width: 680px;
          max-height: 90vh; overflow-y: auto; border-radius: 18px;
        }
        .sl-modal-close {
          position: absolute; top: 14px; right: 16px; z-index: 10;
          background: #262E63; border: none; color: #fff;
          width: 32px; height: 32px; border-radius: 50%;
          font-size: 20px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          line-height: 1;
        }
        .sl-modal-close:hover { background: #3A4060; }

        /* ── Responsive ── */
        @media (max-width: 1024px) {
          .sl-map-list { grid-template-columns: 1fr; }
          .sl-map-area { height: 340px; }
          .sl-store-panel { border-left: none; border-top: 1px solid #E1E3EE; max-height: 420px; }
          .sl-expect-grid { grid-template-columns: repeat(2, 1fr); }
          .sl-vtour-inner { grid-template-columns: 1fr; }
        }
        @media (max-width: 640px) {
          .sl-expect-grid { grid-template-columns: 1fr; }
          .sl-map-list { border-radius: 12px; }
          .gc-scene { height: 320px; perspective: 800px; }
          .gc-caption-desc { display: none; }
        }
      `}</style>

      {/* ══ HERO (dark, no image, matches Careers/Policies) ══ */}
      <div className="sl-hero">
        <div className="sl-hero-grid" />
        <div className="sl-hero-inner">
          <div className="sl-hero-eyebrow">Store Locator · PR Hospital Designers Hospital Infrastructure</div>
          <h1>Find the best hospital infrastructure designers near you</h1>
          <p>Visit a PR Hospital Designers Experience Centre near you and consult our clinical specialists in person.</p>
          <button className="sl-hero-cta" onClick={openConsultation}>Book Free Consultation</button>
        </div>
      </div>

      {/* ══ BREADCRUMB ══ */}
      <div className="sl-breadcrumb">
        Home / <span>Store Locator</span>
      </div>

      {/* ══ FIND US ══ */}
      <div className="sl-find-section">
        <div className="sl-find-header">
          <div>
            <h2>Find us here</h2>
            <p>Locate us in your city and drop in! We'd love to meet you.</p>
          </div>
          <button className="sl-connect-btn" onClick={openConsultation}>Let's Connect</button>
        </div>

        <div className="sl-map-list">
          <div className="sl-map-area">
            <iframe
              src={STORES[activeStore].mapEmbed}
              title={STORES[activeStore].name}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="sl-store-panel">
            <div className="sl-panel-count">{STORES.length} Experience Centres</div>
            {STORES.map((store, idx) => (
              <div
                key={store.id}
                className={`sl-store-item${activeStore === idx ? " active" : ""}`}
                onClick={() => setActiveStore(idx)}
              >
                <div className="sl-store-item-name">{store.name}</div>
                <div className="sl-store-item-tag">{store.tag}</div>
                <div className="sl-store-item-addr">{store.address}</div>
                <div className="sl-store-item-meta"><span>Monday to Saturday</span> | 10 AM – 7 PM</div>
                <div className="sl-store-item-meta" style={{ marginBottom: 0 }}>{store.tourDuration}</div>
                <div className="sl-store-item-actions">
                  <button className="sl-book-btn" onClick={(e) => { e.stopPropagation(); openConsultation(); }}>Enquire Now</button>
                  <a href={`tel:${store.phone}`} className="sl-icon-btn" title="Call" onClick={(e) => e.stopPropagation()}>📞</a>
                  <a href="https://wa.me/919993999840" className="sl-icon-btn" title="WhatsApp" target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>💬</a>
                  <button className="sl-explore-btn" onClick={(e) => { e.stopPropagation(); window.open(store.directionsLink, "_blank"); }}>EXPLORE →</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ WHAT TO EXPECT ══ */}
      <div className="sl-expect">
        <div className="sl-expect-inner">
          <h2>What can I expect at the Experience Centres?</h2>
          <p className="sl-expect-sub">Experience endless options for everything hospital infrastructure</p>
          <div className="sl-expect-grid">
            {EXPECT_ITEMS.map((item, i) => (
              <div className="sl-expect-card" key={i}>
                <img src={item.img} alt={item.title} />
                <div className="sl-expect-card-body">
                  <div className="sl-expect-card-title">{item.title}</div>
                  <div className="sl-expect-card-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ GLOBE CAROUSEL ══ */}
      <div className="sl-peek">
        <h2 className="sl-peek-title">A sneak-peek into our Experience Centres</h2>
        <p className="sl-peek-sub">Click a card or drag to rotate</p>
        <GlobeCarousel />
      </div>

      {/* ══ VIRTUAL TOUR ══ */}
      <div className="sl-vtour">
        <div className="sl-vtour-inner">
          <div>
            <h2>Take a 360° virtual tour of our Experience Centre</h2>
            <p>Can't visit us in person right now? Take a virtual walkthrough of our hospital infrastructure experience centre and explore OT models, ICU suites, and diagnostic centre layouts from your screen.</p>
            <button className="sl-vtour-btn">▶ Start the Tour</button>
          </div>
          <div className="sl-vtour-img" style={{ overflow: "hidden", borderRadius: "12px", position: "relative", width: "100%", aspectRatio: "16/9" }}>
            <div style={{ position: "absolute", top: "-60px", left: "-2px", right: "-2px", bottom: "-80px" }}>
              <iframe
                src="https://www.youtube.com/embed/PE66MgjpTcI?autoplay=1&mute=1&loop=1&playlist=PE66MgjpTcI&controls=0&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3&disablekb=1&fs=0"
                title="360° Virtual Tour"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ width: "100%", height: "100%", border: "none", display: "block" }}
              />
            </div>

            {/* Transparent blocker — prevents mouse interaction with YouTube controls */}
            <div style={{
              position: "absolute",
              top: 0, left: 0, right: 0, bottom: 0,
              zIndex: 1,
              cursor: "default"
            }} />

            <div className="sl-vtour-img-badge" style={{ zIndex: 2 }}>
              <span>▶</span> 360° Virtual Tour
            </div>
          </div>
        </div>
      </div>

      {/* ══ REVIEWS ══ */}
      <div className="sl-reviews">
        <div className="sl-reviews-inner">
          <div>
            <h2>PR Hospital Designers Hospital Infrastructure Reviews</h2>
            <p>These reviews motivate us to provide our clients top-quality hospital design experiences.</p>
          </div>
          <div className="sl-reviews-badge">
            <span className="sl-google-icon">G</span>
            <div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                <span className="sl-rating-num">4.8</span>
                <span className="sl-stars">★★★★★</span>
              </div>
              <div className="sl-review-count">based on Google Reviews</div>
            </div>
          </div>
        </div>
      </div>

      {/* ══ FAQ ══ */}
      <div className="sl-faq">
        <div className="sl-faq-inner">
          <h2>Hospital Infrastructure Near Me — FAQs</h2>
          {FAQS.map((faq, i) => (
            <div key={i} className={`sl-faq-item${openFaq === i ? " open" : ""}`}>
              <button className="sl-faq-btn" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{faq.q}</span>
                <span className={`sl-faq-icon${openFaq === i ? " open" : ""}`}>+</span>
              </button>
              {openFaq === i && <div className="sl-faq-ans">{faq.a}</div>}
            </div>
          ))}
        </div>
      </div>

      {/* ══ DREAM BANNER ══ */}
      <div className="sl-dream">
        <div className="sl-dream-dots" />
        <div className="sl-dream-inner">
          <h2>Your dream hospital is just a click away</h2>
          <br />
          <button className="sl-dream-btn" onClick={openConsultation}>Get Started</button>
        </div>
      </div>

      {/* ══ CONSULTATION MODAL ══ */}
      {showConsultation && (
        <div
          className="sl-modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) closeConsultation(); }}
        >
          <div className="sl-modal-inner">
            <button className="sl-modal-close" onClick={closeConsultation} aria-label="Close consultation form">
              ×
            </button>
            <Consultation />
          </div>
        </div>
      )}
    </div>
    </>
  );
}